import { isEmpty } from 'lodash-es';
import React, { useCallback, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { WsDrawer } from 'wisestep-base';

import ErrorLogger from '../../../../providers/ErrorLogger';
import { useConversationWidgetStore } from '../../../../utils/useConversationWidgetStore';
import JobSelection from '../../../conversationWidget/components/JobSelection';
import conversationWidgetStore from '../../../conversationWidget/store/conversationWidgetStore';
interface IActionWidgetProps {
  onSelect(): void;
  fromPage: string;
  action: 'email' | 'sms' | 'call' | 'mapping' | 'submission' | 'task' | 'rtr';
  candidateId: string;
}

const ActionWidget = ({ onSelect, fromPage, action = 'sms', candidateId }: IActionWidgetProps) => {
  const [allowSelection, setAllowSelection] = useState(true);
  const selectedJob = conversationWidgetStore((state) => state.selectedJob);
  const openModalWithAction = useConversationWidgetStore((state) => state.openModalWithAction);

  const onJobSelection = useCallback(() => {
    onSelect();
    setAllowSelection(false);
    openModalWithAction(candidateId, `${fromPage}`, action);
  }, [action, candidateId, fromPage, onSelect, openModalWithAction]);

  useEffect(() => {
    !isEmpty(selectedJob) && onJobSelection();
  }, [onJobSelection, selectedJob]);

  return (
    <>
      <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
        {allowSelection && (
          <WsDrawer
            open={allowSelection}
            style={{ zIndex: '1300' }}
            hideHeader={true}
            onClose={onSelect}
            size="medium"
          >
            <JobSelection onBackButton={onSelect} getJob={onJobSelection} />
          </WsDrawer>
        )}
      </ErrorBoundary>
    </>
  );
};

export default ActionWidget;
